module.exports = __webpack_public_path__ + "static/media/icon-arrow-page.cc145fb8.svg";